






import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as Types from '../../mini'
import { convertPxToVw } from '../../utils'

@Component({})
export default class Blank extends Vue {
  @Prop() data: Types.BlankComp

  @Watch('data.compMargin')
  dataChange(newData) {
    console.log(newData)
  }
  get blankStyle() {
    return {
      height: convertPxToVw(this.data.compMargin) + 'vw',
      background: this.data.bgColor,
    }
  }
  created() {}
}
